import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header container" }
const _hoisted_2 = { class: "header__nav nav" }
const _hoisted_3 = { class: "nav__list" }
const _hoisted_4 = { class: "nav__item" }
const _hoisted_5 = { class: "nav__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "header__logo"
    }, {
      default: _withCtx(() => [
        _createTextVNode("WeatherApp")
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/doc",
            class: "nav__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Documentation")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}